import styled from 'styled-components';

export const CategoriesSection = styled.div`
	margin-top: 16px;
`;

export const CategoriesTitle = styled.h3`
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 12px;
	color: ${({ theme }) => theme.colors.black};
`;

export const CategoriesContainer = styled.div`
	display: flex;
	gap: 16px;
`;

export const CategoriesList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	flex: 1;
	max-width: 50%;
`;

export const ChartContainer = styled.div`
	flex: 1;
	max-width: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${({ theme }) => theme.colors.white};
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.colors.grey4};
	min-height: 250px;
`;

export const ChartPlaceholder = styled.div`
	color: ${({ theme }) => theme.colors.grey2};
	font-style: italic;
	text-align: center;
`;

export const CategoryItem = styled.div<{ selected?: boolean }>`
	display: flex;
	align-items: center;
	padding: 12px 16px;
	background-color: ${({ theme }) => theme.colors.white};
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.colors.grey4};
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	${({ selected, theme }) =>
		selected &&
		`
		border-color: ${theme.colors.punchupOrange};
		border-width: 2px;
		box-shadow: 0 0 0 2px ${theme.colors.punchupOrange}33;
		transform: translateY(-1px);
	`}
`;

export const CategoryColor = styled.div<{ color: string }>`
	width: 16px;
	height: 16px;
	border-radius: 50%;
	background-color: ${({ color }) => color};
	margin-right: 12px;
	flex-shrink: 0;
`;

export const CategoryInfo = styled.div`
	flex: 1;
`;

export const CategoryLabel = styled.div`
	font-weight: 500;
	color: ${({ theme }) => theme.colors.black2};
	margin-bottom: 2px;
`;

export const CategoryPlaces = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.colors.grey2};
`;

export const LoadingState = styled.div`
	padding: 16px;
	text-align: center;
	color: ${({ theme }) => theme.colors.grey2};
	font-style: italic;
`;

export const ErrorState = styled.div`
	padding: 16px;
	text-align: center;
	color: ${({ theme }) => theme.colors.red};
	font-size: 14px;
`;

export const ChartContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px;
	height: 100%;
	width: 100%;
`;

export const ChartTitle = styled.h4`
	margin: 0 0 16px 0;
	font-size: 18px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.black};
	text-align: center;
`;

export const ChartThumbnail = styled.img`
	width: 100%;
	max-width: 400px;
	height: auto;
	border-radius: 8px;
	margin-bottom: 16px;
	box-shadow: ${({ theme }) => theme.shadows.cardShadow};
`;

export const ChartInfo = styled.div`
	font-size: 15px;
	color: ${({ theme }) => theme.colors.grey};
	text-align: center;
	font-weight: 500;
`;
